export default __webpack_public_path__ + "static/media/not-connected.dd4da797.svg";